var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M152 184.019H423.494L296.312 74.183C286.281 65.527 285.188 50.372 293.844 40.341C302.531 30.279 317.688 29.154 327.688 37.873L503.688 189.863C508.969 194.425 512 201.049 512 208.018C512 214.986 508.969 221.611 503.688 226.173L327.688 378.163C323.156 382.1 317.562 384.006 312 384.006C305.281 384.006 298.594 381.194 293.844 375.694C285.188 365.664 286.281 350.508 296.312 341.853L423.494 232.016H152C94.656 232.016 48 278.669 48 336.009V456.002C48 469.251 37.25 480 24 480S0 469.251 0 456.002V336.009C0 252.202 68.188 184.019 152 184.019Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.0fc992dff63958f9862b551b8eb1c162.svg";
export { ForwardRef as ReactComponent };